import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { ISbComponentType } from 'storyblok-js-client';
import type Stripe from 'stripe';
import { getAllRouteData } from '../lib/get-all-route-data';

@Injectable({
  providedIn: 'root',
})
export class StoryblokHelperService {
  private route = inject(ActivatedRoute);

  readonly tempUpdateCache = new Map<
    string,
    | ISbStoryData<
        ISbComponentType<string> & {
          [index: string]: unknown;
        }
      >[]
    | Stripe.Price[]
  >();

  public getBlocks(items: { component: string }[], components: string[], returnEarly = false) {
    return this.getBlocksInternal(items, components, returnEarly);
  }

  private getBlocksInternal(items: { component: string }[], components: string[], returnEarly = false) {
    const blocks = [];
    if (!items) return blocks;
    for (const item of items) {
      if (components.includes(item.component)) {
        blocks.push(item);
        if (returnEarly) return blocks;
      }
      for (const key in item) {
        if (Array.isArray(item[key])) {
          blocks.push(...this.getBlocksInternal(item[key], components));
          if (returnEarly && blocks.length) return blocks;
        }
      }
    }
    return blocks;
  }

  public getContentTypes(items: { type: string }[], types: string[]) {
    const blocks = [];
    if (!items) return blocks;
    for (const item of items) {
      if (types.includes(item.type)) {
        blocks.push(item);
      }
      for (const key in item) {
        if (Array.isArray(item[key])) {
          blocks.push(...this.getContentTypes(item[key], types));
        }
      }
    }
    return blocks;
  }

  public getGlobalData(key: string) {
    if (this.tempUpdateCache.has(key)) {
      return this.tempUpdateCache.get(key);
    }
    const routeData = getAllRouteData(this.route.snapshot);
    return routeData[key];
  }
}
